
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const AffiliateHowItWorks = () => {
  return (
    <Card className="mb-8">
      <CardHeader className="bg-green-light">
        <CardTitle className="text-primary-dark">How Our Referral System Works</CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="grid md:grid-cols-1 gap-6">
          <div>
            <h4 className="font-semibold text-lg mb-3">For Partners:</h4>
            <ol className="list-decimal list-inside space-y-2 text-gray-700">
              <li>Apply and get approved as an affiliate partner</li>
              <li>Receive your unique referral code (e.g., "PARTNER123")</li>
              <li>Share your code with potential customers</li>
              <li>Track your referrals and commissions through our partner portal</li>
              <li>Receive monthly payouts for successful referrals</li>
            </ol>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AffiliateHowItWorks;
